/**
 * @fileoverview Select - Public API
 */
export { Select, type SelectProps } from "./select";
